const PANEL_TOGGLE_FOCUS_SELECTOR =
  'button[data-docked-panel-toggle], button[aria-label="Close panel"], button[aria-label="Open panel"]'

export function restorePanelFocusAfterClose(returnTarget: HTMLElement | null) {
  requestAnimationFrame(() => {
    if (returnTarget?.isConnected) {
      returnTarget.focus()
    } else {
      document.querySelector<HTMLElement>(PANEL_TOGGLE_FOCUS_SELECTOR)?.focus()
    }
  })
}

export function restoreFocusOnNextFrame(target: HTMLElement | null | undefined) {
  requestAnimationFrame(() => {
    if (target?.isConnected) {
      target.focus()
    }
  })
}
